import { systemEngineEnvironment } from "services/environment/systemEngine";

import { Privilege, PrivilegeObjectType } from "./types";

/**
 * As far as organization and account roles are called the same "roles",
 * in order to distinguish between them, we override the object_type.
 */
export const getOrganizationPrivileges = async (loginName: string) => {
  const sql = `
    select
      op.object_name,
      CASE
        WHEN op.object_type = 'role' THEN '${PrivilegeObjectType.organization_role}'
        ELSE op.object_type
        END AS object_type,
      op.privilege_type
    from
      org_db.information_schema.transitive_applicable_roles tar
        join org_db.information_schema.object_privileges op on tar.role_name = op.grantee
    where
      LOWER(tar.grantee) = LOWER('${loginName}')
    group by
      op.object_name,
      op.object_type,
      op.privilege_type;
`;

  const result = await systemEngineEnvironment.execute<Privilege>(sql);

  const [response] = result;
  return response.rows;
};
